module.exports = __webpack_public_path__ + "img/report_done.5e09ce6f.svg";